import React from 'react';
import { Form } from '@douyinfe/semi-ui';
import styles from './ModuleBase.module.scss';
import ColorPicker from '../../../ColorPicker';

const ModuleBase = ({ children, onEdit, style = {}, height, className }) => {
    const defaultStyle = {
        minHeight: '100px',
        overflow: 'hidden',
        position: 'relative'
    };

    const combinedStyle = { ...defaultStyle, ...style, height };

    return (
        <div className={`${styles.moduleBase} ${className || ''}`} style={combinedStyle}>
            <div className={styles.moduleContent}>
                {children}
            </div>
        </div>
    );
};

export const ModuleStyleForm = ({ style = {}, onChange }) => {
    const defaultStyle = {
        padding: '16px',
        marginTop: '0px',
        marginBottom: '0px',
        marginLeft: '0px',
        marginRight: '0px',
        borderRadius: '6px',
        minHeight: '100px',
        backgroundColor: '#ffffff'
    };

    const [historyColors, setHistoryColors] = React.useState(() => {
        const saved = localStorage.getItem('moduleStyleHistoryColors');
        return saved ? JSON.parse(saved) : [];
    });


    const parseStyleValue = (value) => {
        if (value === undefined || value === null) return null;
        if (typeof value === 'string') {
            const match = value.match(/^(\d+)px$/);
            return match ? parseInt(match[1]) : value;
        }
        return value;
    };

    const handleStyleChange = (field, value) => {
        const newValue = typeof value === 'number' ? `${value}px` : value;
        const newStyle = { ...defaultStyle, ...style, [field]: newValue };
        style = { ...newStyle }
        console.log("style", style)
        onChange?.(newStyle);
    };


    return (
        <Form
            labelPosition="left"
            labelAlign="right"
            style={{ gap: 8 }}
            initValues={{
                padding: parseStyleValue(style.padding) ?? parseStyleValue(defaultStyle.padding),
                marginTop: parseStyleValue(style.marginTop) ?? parseStyleValue(defaultStyle.marginTop),
                marginBottom: parseStyleValue(style.marginBottom) ?? parseStyleValue(defaultStyle.marginBottom),
                marginLeft: parseStyleValue(style.marginLeft) ?? parseStyleValue(defaultStyle.marginLeft),
                marginRight: parseStyleValue(style.marginRight) ?? parseStyleValue(defaultStyle.marginRight),
                borderRadius: parseStyleValue(style.borderRadius) ?? parseStyleValue(defaultStyle.borderRadius),
                minHeight: parseStyleValue(style.minHeight) ?? parseStyleValue(defaultStyle.minHeight),
                backgroundColor: style.backgroundColor ?? defaultStyle.backgroundColor
            }}
        >
            <Form.Section text="基础样式" expandable={true} defaultExpanded={false}>
                <Form.InputNumber
                    field="padding"
                    label="内边距"
                    onChange={(value) => handleStyleChange('padding', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="marginTop"
                    label="上边距"
                    onChange={(value) => handleStyleChange('marginTop', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="marginLeft"
                    label="左边距"
                    onChange={(value) => handleStyleChange('marginLeft', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="marginRight"
                    label="右边距"
                    onChange={(value) => handleStyleChange('marginRight', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="marginBottom"
                    label="下边距"
                    onChange={(value) => handleStyleChange('marginBottom', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="borderRadius"
                    label="圆角"
                    onChange={(value) => handleStyleChange('borderRadius', value)}
                    suffix="px"
                    defaultValue={0}
                />
                <Form.InputNumber
                    field="minHeight"
                    label="最小高度"
                    onChange={(value) => handleStyleChange('minHeight', value)}
                    suffix="px"
                    defaultValue={100}
                />
                <Form.Slot label="背景颜色">
                    <ColorPicker
                        value={style.backgroundColor || defaultStyle.backgroundColor}
                        onChange={(color) => handleStyleChange('backgroundColor', color)}
                    />
                </Form.Slot>
            </Form.Section>
        </Form>
    );
};

export const ButtonStyleForm = ({ style = {}, onChange }) => {
    const defaultStyle = {
        textColor: '#fff',
        backgroundColor: 'var(--semi-color-primary)',
        fontSize: '16px',
        width: '200px',
        height: '40px',
        borderRadius: '20px',
        animation: 'none',
        bottom: '20px'
    };

    const parseStyleValue = (value, defaultValue) => {
        if (value === undefined || value === null) return parseInt(defaultValue);
        if (typeof value === 'string') {
            const match = value.match(/^(\d+)px$/);
            return match ? parseInt(match[1]) : value;
        }
        return value;
    };

    const handleStyleChange = (field, value) => {
        const newValue = ['width', 'height', 'fontSize', 'borderRadius'].includes(field) && typeof value === 'number' ? `${value}px` : value;
        const newStyle = { ...style, [field]: newValue }
        style = { ...newStyle }
        onChange?.(newStyle);
    };

    return (
        <Form
            labelPosition="left"
            labelAlign="right"
            style={{ gap: 8 }}
            initValues={{
                fontSize: parseStyleValue(style.fontSize, defaultStyle.fontSize),
                width: parseStyleValue(style.width, defaultStyle.width),
                height: parseStyleValue(style.height, defaultStyle.height),
                borderRadius: parseStyleValue(style.borderRadius, defaultStyle.borderRadius),
                textColor: style.textColor || defaultStyle.textColor,
                backgroundColor: style.backgroundColor || defaultStyle.backgroundColor,
                animation: style.animation || defaultStyle.animation,
                bottom: parseStyleValue(style.bottom, defaultStyle.bottom)
            }}
        >
            <Form.Section text="按钮样式">
                <Form.Slot label="文字颜色">
                    <ColorPicker
                        value={style.textColor || defaultStyle.textColor}
                        onChange={(color) => handleStyleChange('textColor', color)}
                    />
                </Form.Slot>
                <Form.Slot label="背景颜色">
                    <ColorPicker
                        value={style.backgroundColor || defaultStyle.backgroundColor}
                        onChange={(color) => handleStyleChange('backgroundColor', color)}
                    />
                </Form.Slot>
                <Form.InputNumber
                    field="fontSize"
                    label="字体大小"
                    onChange={(value) => handleStyleChange('fontSize', value)}
                    suffix="px"
                    defaultValue={16}
                />
                <Form.InputNumber
                    field="width"
                    label="按钮宽度"
                    onChange={(value) => handleStyleChange('width', value)}
                    suffix="px"
                />
                <Form.InputNumber
                    field="height"
                    label="按钮高度"
                    onChange={(value) => handleStyleChange('height', value)}
                    suffix="px"
                />
                <Form.InputNumber
                    field="borderRadius"
                    label="圆角大小"
                    onChange={(value) => handleStyleChange('borderRadius', value)}
                    suffix="px"
                />
                <Form.Select
                    field="animation"
                    label="动画效果"
                    value={style.animation || defaultStyle.animation}
                    onChange={(value) => handleStyleChange('animation', value)}
                    style={{ width: '100%' }}
                >
                    <Form.Select.Option value="none">无动画</Form.Select.Option>
                    <Form.Select.Option value="pulse">脉冲</Form.Select.Option>
                    <Form.Select.Option value="bounce">弹跳</Form.Select.Option>
                </Form.Select>
                <Form.InputNumber
                    field="bottom"
                    label="底部间距"
                    value={parseStyleValue(style.bottom, defaultStyle.bottom)}
                    onChange={(value) => handleStyleChange('bottom', value)}
                    suffix="px"
                />
            </Form.Section>
        </Form>
    );
};

export default ModuleBase;